import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'preact/hooks';
import { useStyles } from '../../../../common/hooks/useStyles';
import { mediaDataSelector } from '../../../../common/store/selectors/mediaData.selector';
import { getSmallNextVideoId, getThumbnailId } from '../../htmlElements/htmlElementsIdGetter';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { isEmpty } from '../../../../common/utils/utils';
import { CountdownLoader } from '../countdownLoader/countdownLoader';
import { getNextVideoStyleObject } from './nextVideoSmallSize.style';
import { Title } from '../title/title';

const ARIA_LABEL = 'Play next video';

interface NextVideoComponentVariablesProps {
    countdownTime: number;
    onClickNextVideo: () => void;
}

export const NextVideoSmallSize: FunctionComponent<NextVideoComponentVariablesProps> = props => {
  const {
    countdownTime,
    onClickNextVideo,
  } = props;

  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const videoList = useSelector(mediaDataSelector.videoList);
  const activeVideoIndex = useSelector(mediaDataSelector.activeVideoIndex);

  const [nextVideoThumbnail, setNextVideoThumbnail] = useState('');

  const isLastVideo = activeVideoIndex === videoList.length - 1;

  const styles = useStyles(getNextVideoStyleObject, []);
  const { nextVideoContainerStyle, thumbnailStyle, thumbnailWrapperStyle } = styles;

  useEffect(() => {
    const nextVideoIndex = isLastVideo ? 0 : activeVideoIndex + 1;
    if (!isEmpty(videoList)) {
      const { thumbnail } = videoList[nextVideoIndex];
      setNextVideoThumbnail(thumbnail);
    }
  }, [activeVideoIndex, isLastVideo, videoList]);

  const onKeyDownNextVideo = (event: any): void => {
    if (event.key === 'Enter') {
      onClickNextVideo();
    }
  };

  return (
    <div style={nextVideoContainerStyle} onClick={onClickNextVideo} id={getSmallNextVideoId(playerUniqueId)} tabIndex={0} aria-label={ARIA_LABEL} onKeyDown={onKeyDownNextVideo}>
      <div id={getThumbnailId(playerUniqueId)} style={thumbnailWrapperStyle}>
        <img src={nextVideoThumbnail} alt="next video thumbnail" style={thumbnailStyle} />
        <CountdownLoader smallNextVideo countdownTime={countdownTime} onClickNextVideo={onClickNextVideo} />
      </div>
      <Title playerUniqueId={playerUniqueId} smallNextVideo />
    </div>
  );
};
